import { http } from './HttpService.js'

export default {
	load(params = '') {
		return http.get('vendas' + params)
	},
	loadCFOP(params = '') {
		return http.get('vendas/cfop' + params)
	},
	loadCFOPMfe(params = '') {
		return http.get('vendas/cfop/mfe' + params)
	},
	loadPorVendedores(params = '') {
		return http.get('vendas/vendedores' + params)
	},
	loadCategoria(params = '') {
		return http.get('vendas/categorias' + params)
	},
	loadCategoriaFiscal(params = '') {
		return http.get('vendas/categoriasFiscal' + params)
	},
	loadPorProduto(params = '') {
		return http.get('vendas/produtos' + params)
	},
	loadPorCliente(params = '') {
		return http.get('vendas/cliente' + params)
	},
	loadChartPagamentos(params = '') {
		return http.get('vendas/charts/pagamentos' + params)
	},
	loadLucro(params = '') {
		return http.get('lucro' + params)
	},
	loadChartVendaDiaMes(params = '') {
		return http.get('vendas/charts/diaMes' + params)
	},
	loadChartHorarios(params = '') {
		return http.get('vendas/charts/horarios' + params)
	},
	geraRelatorioDataPDF(params = '') {
		return http.get('relatorioDataPDF'+params)
	},
	geraRelatorioPDF(params = '') {
		return http.get('relatorioFiscal'+params)
	},
	geraRelatorioDataExcel(params = '') {
		return http.get('relatorioDataExcel'+params)
	},
	geraRelatorioProdutoPDF(params = '') {
		return http.get('relatorioProdutoPDF'+params)
	},
	geraRelatorioProdutoExcel(params = '') {
		return http.get('relatorioProdutoExcel'+params)
	}
}
